import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from 'reactstrap';
import axios from 'axios';

import './AddUser.scss';
import { env } from '../../../../../shared/environment';
import Success from '../../../../../shared/components/success';

class AddUser extends Component {
  baseUrl = env.baseUrl;

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      userID: this.props.id,
      full_name: this.props.full_name ? this.props.full_name : '',
      email: this.props.email ? this.props.email : '',
      role: this.props.role ? this.props.role : 'editor',
      password: '',
      confirmPassword: '',
      success: false,
      error: false,
      errorMessage: '',
      isLoading: false,
    };

    this.toggle = this.toggle.bind(this);
    this.onChangeFullname = this.onChangeFullname.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangeRole = this.onChangeRole.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onChangeConfirmPassword = this.onChangeConfirmPassword.bind(this);
    this.addUser = this.addUser.bind(this);
    this.editUser = this.editUser.bind(this);
  }

  componentWillReceiveProps(props) {
    this.setState({
      userID: props.id,
      full_name: props.full_name ? props.full_name : '',
      email: props.email ? props.email : '',
      role: props.role ? props.role : 'editor',
    });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });

    this.props.onSuccess();
  }

  onChangeFullname(event) {
    this.setState({ full_name: event.target.value });
  }

  onChangeEmail(event) {
    this.setState({ email: event.target.value });
  }

  onChangeRole(event) {
    this.setState({ role: event.target.value });
  }

  onChangePassword(event) {
    this.setState({ password: event.target.value });
  }

  onChangeConfirmPassword(event) {
    this.setState({ confirmPassword: event.target.value });
  }

  addUser() {
    const params = {
      full_name: this.state.full_name,
      email: this.state.email,
      password: this.state.password,
      role: this.state.role,
    };

    if (this.state.full_name.length < 4) {
      this.setState({
        errorMessage: 'ФИО должно содержать не менее 5 символов!',
      });
    } else if (this.state.email.length < 4) {
      this.setState({
        errorMessage: 'Email должен содержать не менее 5 символов!',
      });
    } else if (this.state.role !== 'editor' && this.state.role !== 'admin') {
      this.setState({
        errorMessage: 'Неправильный роль!',
      });
    } else if (this.state.password.length < 5) {
      this.setState({
        errorMessage: 'Пароль должен содержать не менее 6 символов!',
      });
    } else if (this.state.password !== this.state.confirmPassword) {
      this.setState({
        errorMessage: 'Пароли не совпадают!',
      });
    } else {
      this.setState({ isLoading: true });
      axios
        .post(`${this.baseUrl}users/add`, params)
        .then((response) => {
          if (response.data.code == 200) {
            this.setState({
              isLoading: false,
              success: true,
              full_name: '',
              email: '',
              password: '',
              confirmPassword: '',
            });

            this.toggle();
          } else {
            this.setState({
              isLoading: false,
              error: true,
              errorMessage: response.data.message,
            });
          }
        })
        .catch((error) => {
          console.log('err: ', error);
        });
    }
  }

  editUser() {
    const params = {
      id: this.state.userID,
      full_name: this.state.full_name,
      email: this.state.email,
      password: this.state.password,
      role: this.state.role,
    };

    if (this.state.full_name.length < 4) {
      this.setState({
        errorMessage: 'ФИО должно содержать не менее 5 символов!',
      });
    } else if (this.state.email.length < 4) {
      this.setState({
        errorMessage: 'Email должен содержать не менее 5 символов!',
      });
    } else if (this.state.role !== 'editor' && this.state.role !== 'admin') {
      this.setState({
        errorMessage: 'Неправильный роль!',
      });
    } else {
      this.setState({ isLoading: true });
      axios
        .put(`${this.baseUrl}users/update`, params)
        .then((response) => {
          if (response.data.code == 200) {
            this.setState({
              isLoading: false,
              success: true,
            });

            this.toggle();
          } else {
            this.setState({
              isLoading: false,
              error: true,
              errorMessage: response.data.message,
            });
          }
        })
        .catch((error) => {
          console.log('err: ', error);
        });
    }
  }

  render() {
    const closeBtn = (
      <button className="close" onClick={this.toggle}>
        &times;
      </button>
    );

    return (
      <div className={this.props.float} style={{ display: 'inline-block' }}>
        <Button
          color="success"
          className={this.props.btnClass}
          onClick={this.toggle}
        >
          <i className={this.props.icon}></i> {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          backdrop={'static'}
        >
          <ModalHeader toggle={this.toggle} close={closeBtn}>
            {this.props.modalHeader}
          </ModalHeader>
          <ModalBody>
            <div className="form-group">
              <label htmlFor="name">ФИО</label>
              <input
                type="text"
                className="form-control"
                id="name"
                onChange={this.onChangeFullname}
                value={this.state.full_name}
                name="name"
                maxLength="50"
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                onChange={this.onChangeEmail}
                value={this.state.email}
                name="email"
                maxLength="50"
              />
            </div>
            <div className="form-group">
              <label htmlFor="role">Роль</label>
              <select
                className="form-control"
                onChange={this.onChangeRole}
                value={this.state.role}
                id="role"
                name="role"
              >
                <option value="editor">Editor</option>
                <option value="admin">Admin</option>
              </select>
            </div>
            {this.props.action == 'add' ? (
              <div>
                <div className="form-group">
                  <label htmlFor="password">Пароль</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    onChange={this.onChangePassword}
                    value={this.state.password}
                    name="password"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="confirmPassword">Подтвердите пароль</label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    onChange={this.onChangeConfirmPassword}
                    value={this.state.confirmPassword}
                    name="confirmPassword"
                  />
                </div>
              </div>
            ) : (
              ''
            )}
            {this.state.success ? (
              <Alert color="success">{this.props.successMessage}</Alert>
            ) : (
              ''
            )}
            {this.state.errorMessage ? (
              <Alert color="danger">{this.state.errorMessage}</Alert>
            ) : (
              ''
            )}
          </ModalBody>
          <ModalFooter>
            {this.state.isLoading ? <div className="loading"></div> : ''}
            <Button
              color="success"
              onClick={
                this.props.action == 'add' ? this.addUser : this.editUser
              }
            >
              Сохранить
            </Button>
            <Button color="secondary" onClick={this.toggle}>
              Отмена
            </Button>
          </ModalFooter>
        </Modal>
        {this.state.success ? <Success /> : ''}
      </div>
    );
  }
}

export default AddUser;
